<template>
  <div class="container-fluid p-0">
    <div v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>
      <h4 class="w-100 text-center" v-if="deviceReports.length === 0">در حال حاضر این دستگاه هیچ برنامه بازدید یا سرویسی ندارد</h4>
      <div class="row mb-2" v-else>

        <div class="col-6 mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom  w-100">
              <div class="input-group-text">
                <span>انتخاب دستگاه</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="deviceReports"
                :header="{label:'companyName'}"
                :mode="'edit'"
                @dataChanged="deviceSelect"
              ></vs-select>
            </div>
          </div>
        </div>
        <div class="col-6 mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom  w-100">
              <div class="input-group-text">
                <span>انتخاب چک لیست</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="checkLists"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="checkListSelect"
              ></vs-select>
            </div>
          </div>
        </div>

        <h5 class="col-12 text-center">نمودار دستگاه
          {{selectedDeviceName}}
          چک لیست
          {{selectedCheckListName}}
        </h5>
        <div class="col-lg-12 col-12 my-5">
          <div class="card shadow text-white mb-1">
            <div class="card-body pb-0">
              <div class="card-chart">
                <canvas id="area-chart" width="1600" height="400"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------------------------------------------------------------->
    <!------------ ATTACH MODAL----------------------------------------------------------------------------->

    <!------------ SHENASNAMEH  MODALS -------------------------------------------------------------------->


  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import Moment from "moment-jalali";
  import Vue from "vue";
  import Products from "../Products.vue";
  import * as $ from 'jquery';
  import checkAccess from "../../checkAccess";
  import CreateWork from "../CreateWork";
  import Utils from "../../_framework/utils/Utils";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Constants from "../../Constants";
  import BdInput from "../../components/BDInput";
  import Chart from "chart.js";

  export default {
    name: "device-report-services",
    props: {},
    components: {
      BdInput,
      CreateWork,
      VsSelect,
      Products,
      datePicker: DatePicker,
    },
    data: function () {
      return {

        isLoading: false,
        companyId: 0,
        deviceReports: [],
        curveReport: [],
        enPMListTypes: [],
        checkLists: [],

        p_enPMListType: 0,
        p_name: "",
        p_unit: "",
        p_device: "",
        areaChart: {},
        selectedDeviceId: 0,
        selectedDeviceName: "",
        selectedCheckListId: 0,
        selectedCheckListName: "",
        labels: [],
        isOks: [],
        dataValues: [],
      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
      this.getDeviceReports();
      this.getType();

      // this.getType();
    },
    methods: {
      getType() {
        new BaseService('PManagment', '/GetEnPMListType').getList().then((response) => {
          this.enPMListTypes = response.data;

          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      getDeviceReports() {
        var a = true;
        new BaseService('PManagment', `/GetServiceDevicePMReport/${a}`).getList().then((response) => {
          this.deviceReports = response.data;

        }).catch((error) => {
          console.log(error)
        });
      },

      deviceSelect(prop, data) {
        // this.checkLists = data.pmCheckLists;
        this.selectedDeviceId = data.companyId;
        this.selectedDeviceName = data.companyName;
        this.areaChart = {};
        new BaseService('PManagment', `/GetDevicePMPlanning/${data.companyId}`).getList().then((response) => {
          this.checkLists = response.data;
          for (let i of this.checkLists) {
            i.name = i.pmCheckList.name;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      checkListSelect(prop, data) {
        this.areaChart = {};
        this.selectedCheckListId = data.id;
        this.selectedCheckListName = data.pmCheckList.name;
        console.log(data)
        new BaseService('PManagment', `/GetPMReport/${data.id}`).getList().then((response) => {
          this.curveReport = response.data;
          this.labels = [];
          this.isOks = [];
          this.dataValues = [];
          for (let i of this.curveReport) {
            i.fDate = Moment(i.reportDate).format("jYYYY/jMM/jDD-HH:mm");
            this.labels.push(i.fDate);
            this.isOks.push(i.isOk? 1:0);
            this.dataValues.push(i.value);
          }
          setTimeout(() => {
            this.showCurve();
          }, 200);
        }).catch((error) => {
          console.log(error)
        });
      },
      showCurve() {
        this.areaChart = new Chart(document.getElementById("area-chart"), {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [
              {
                backgroundColor: "rgba(255,193,7,0.71)",
                borderColor: "rgba(255,143,0,0.71)",
                data: this.isOks,
                label: 'وضعیت(مطوب/نامطوب)',
                fill: 'start',
                // hidden: true,
              },
              {
                backgroundColor: "rgba(205,220,57,0.71)",
                borderColor: "rgba(135,150,40,0.71)",

                data: this.dataValues,
                label: 'مقدار قرائت شده',
                fill: 'start',
              },

            ]
          },
          options: {
            title: {
              text: 'نمودار نگهداری و تعمیرات دستگاه',
              display: true,
              bezierCurve: false
            },
            plugins: {
              filler: {
                propagate: true
              }
            },
          },
        });

      },

    },

    computed: {
      myStylestx1() {
        return {
          height: `${this.tx1Height}px`,
          position: 'relative'
        }
      }
    }
  };

</script>

<style scoped>
  .table th, .table td {
    padding: 0.5rem !important;
  }
</style>
